import React from "react";
import * as Styles from "./label.styles";

export const Label = ({ children }) => <Styles.Label>{children}</Styles.Label>;
